import { AxiosError } from "axios";
import { useState } from "react";
import { useDispatch } from "react-redux";

import { PRODUCT_DOMAIN } from "@/constants";
import axioInstance from "@/libs/axios";
import { setApiError } from "@/store/slices/errors/api-error.slice";
import { OptionalExtra } from "@/types/OptionalExtraType";
import { QuoteData } from "@/types/quote/quote-data";
import { apiErrorMappings } from "@/utils/errors/api-error-map";

export const useRemoveCover = (
  version: string | undefined,
  refference: string | undefined,
  optionalExtras: OptionalExtra | undefined,
  remOptionalExtras: OptionalExtra[] | undefined,
  setIsOpenRemove: (boolean: boolean) => void
) => {
  const [success, setSuccess] = useState<null | QuoteData>();
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useDispatch();

  function changeSelectedTrue(
    data: OptionalExtra[] | undefined,
    removeIttem: OptionalExtra
  ) {
    if (!Array.isArray(data)) {
      return data;
    }

    return data.map((item) => {
      if (item.code === removeIttem.code) {
        return {
          ...item,
          price: item.price.map((priceItem) => ({
            ...priceItem,
            selected: false,
          })),
        };
      }

      return item;
    });
  }

  const fetchRemoveCover: () => Promise<void> = async () => {
    if (version && refference && optionalExtras) {
      setLoading(true);
      try {
        const requestBody = {
          type: "Quote",
          channel: "ONLINE",
          version,
          attributes: {
            domain: PRODUCT_DOMAIN,
            priceResult: {
              optionalExtras: changeSelectedTrue(
                remOptionalExtras,
                optionalExtras
              ),
            },
          },
        };

        const config = {
          data: requestBody,
        };
        const response = await axioInstance.patch(
          `/quote/${refference}/updateOptionalExtras`,
          config
        );
        setSuccess(response.data.data);
      } catch (error) {
        const axiosError = error as AxiosError;
        setIsOpenRemove(false);
        if (axiosError.response?.status === 401) {
          window.parent.location.href = "/";
        } else {
          dispatch(setApiError(await apiErrorMappings(axiosError)));
        }
      } finally {
        setLoading(false);
      }
    }
  };

  return [success, fetchRemoveCover, loading];
};
